<!-- Form Section -->
@if (listOfClients$ | async; as clients) {
  <div class="form-wrapper">
    <form [formGroup]="benefitsFormGroup" class="benefits-form">
      <div class="mat-row">
        <div class="mat-12">
          <mat-label>Client<span class="asterisk-mark">*</span></mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-select">
            <mat-select formControlName="clientId" placeholder="Select Client" (selectionChange)="onSelectionChange($event)" [disableOptionCentering]="true">
              <mat-option>
                <ngx-mat-select-search [formControl]="clientFilterControl" [clearSearchInput]="true" [showToggleAllCheckbox]="false"
                  placeholderLabel="Search Client(s) by ID or Name..." noItemsLabel="No clients found">
                </ngx-mat-select-search>
              </mat-option>
              @if ((filteredClients | async)?.length === 0) {
                <mat-option disabled>
                  No clients found
                </mat-option>
              }
              @for (client of filteredClients | async; track client) {
                <mat-option [value]="client.clientId">
                  {{ client.clientId }} - {{ client.clientName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="mat-row">
        <div class="mat-6 pad-r-1" [ngClass]="
          benefitsFormGroup.controls.planId.disabled
            ? 'disabled-control'
            : null
        ">
          <mat-label>Plan Name<span class="asterisk-mark">*</span></mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-select">
            <mat-select placeholder="Select Plan Name" (selectionChange)="onPlanSelection($event)"
              formControlName="planId">
              <mat-option>
                <ngx-mat-select-search [formControl]="planFilterControl" [clearSearchInput]="true" [showToggleAllCheckbox]="false"
                  placeholderLabel="Search Plan(s) by Name..." noItemsLabel="No plan found">
                </ngx-mat-select-search>
              </mat-option>
              @if ((filteredPlans | async)?.length === 0) {
                <mat-option disabled>
                  No plans found
                </mat-option>
              }
              @if (filteredPlans | async; as plans) {
                @for (plan of plans; track plan) {
                  <mat-option [value]="plan.planId">
                    {{ plan.planName }}
                  </mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="mat-6" [ngClass]="
            benefitsFormGroup.controls.groupId.disabled
              ? 'disabled-control'
              : null
          ">
          <mat-label>Group<span class="asterisk-mark">*</span></mat-label>
          <mat-form-field floatLabel="never" class="full-width mat-custom-select">
            <mat-select placeholder="Select Group" (selectionChange)="onGroupSelection($event)"
              formControlName="groupId" [disableOptionCentering]="true">
              <mat-option>
                <ngx-mat-select-search [formControl]="groupFilterControl" [clearSearchInput]="true" [showToggleAllCheckbox]="false"
                  placeholderLabel="Search Group(s) by ID or Name..." noItemsLabel="No group found">
                </ngx-mat-select-search>
              </mat-option>
              @if ((filteredGroups | async)?.length === 0) {
                <mat-option disabled>
                  No groups found
                </mat-option>
              }
              @if (filteredGroups | async; as groups) {
                <mat-option class="grp-dropdown" *ngFor="let group of filteredGroups| async as groups" [value]="group.groupId">
                  {{ group.groupId }}: {{group.groupName }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="mat-row">
        @if (benefitsFormGroup.controls.groupId.value) {
          <div class="mat-6 pad-r-1 plan-type-select">
            <mat-label>Plan Type</mat-label>
            <mat-form-field floatLabel="never" class="full-width mat-custom-select">
              <mat-select placeholder="Not Available" formControlName="planType">
                <ng-container>
                  @for (plan of planTypes; track plan) {
                    <mat-option [value]="plan">
                      {{ plan }}
                    </mat-option>
                  }
                </ng-container>
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>
    </form>
    <mat-divider></mat-divider>
  </div>
}